import { Getter } from "vuex";
import { IState } from './state';

const jobs: Getter<IState, IState> = (state) => state.jobs
const query: Getter<IState, IState> = (state) => state.query
const total: Getter<IState, IState> = (state) => state.total
const categoryFilters: Getter<IState, IState> = (state) => state.categoryFilters
const pages: Getter<IState, IState> = (state) => state.pages
const page: Getter<IState, IState> = (state) => state.page
const getParams: Getter<IState, IState> = (state) => {
	const filters = JSON.stringify(state.categoryFilters.map(cf => {
		return {
			identifier: cf.identifier,
			values: cf.values.filter(v => v.selected).map(v => v.value)
		}
	}))
	//const sort = JSON.stringify(state.sort.find(s => s.active))
	const params = {
		query: state.query,
		page: state.page,
		filters: filters,
		//sort: sort
	}

	return params
}
const hasFilters: Getter<IState, IState> = (state) => {
	const filtersCount = state.categoryFilters.reduce((acc, curr) => {
		return acc + curr.values.filter(v => v.selected).length;
	}, 0);
	return filtersCount > 0;
}
const title: Getter<IState, IState> = (state) => state.title
const description: Getter<IState, IState> = (state) => state.description
const sorts: Getter<IState, IState> = (state) => state.sort
const extraLinks: Getter<IState, IState> = state => state.extraLinks

export default {
	jobs,
	total,
	categoryFilters,
	pages,
	page,
	getParams,
	hasFilters,
	title,
	description,
	sorts,
	query,
	extraLinks
}
